import React, { useEffect, useState } from "react";
import { DataGridPro as DataGrid } from "@mui/x-data-grid-pro";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { useSelector } from "react-redux";
import Modal from "../components/widgets/Modal.js";
import { getPatrolsColumns } from "../components/grids/patrolsGrid.js";
import { useNavigate } from "react-router-dom";

const PatrolsPage = () => {
  const navigate = useNavigate();
  const [selectedEntity, setSelectedEntity] = useState(null);
  const rows = useSelector((state) => state.patrols.allPatrols) || [];
  const isLoading = useSelector((state) => state.isLoading);
  const [showModal, setShowModal] = useState(false);
  const constants = useSelector(state => state.constants.data);
  

  const handleRowClick = (params) => {
    setSelectedEntity(params.row);
    setShowModal(true);
  };

  useEffect(() => {}, []);

  
  function renderLocation(params) {
    const handleNavigate = (e) => {
      
      e.stopPropagation();
      e.preventDefault();
      
      navigate(`/tasks/patrolId/${params.row.id}`);
    }

    if(params.row.status.code == 'OFFD') {
      return (<></>);
    }

    return (<a href="#" onClick={handleNavigate}>Open on Map</a>)
  }
  
  const locationColumn =  {
    field: 'location',
    headerName: 'Location',
    headerAlign: 'left',
    align: 'left',
    flex: 1,
    maxWidth: 100,
    renderCell: (params) => renderLocation(params),
  };

  const [paginationModel, setPaginationModel] = useState({page: 0, pageSize: 20});

  return (
    <>
      <Box sx={{ width: "100%", padding: '20px' }}>
        <Typography component="h1" variant="subtitle2">
          Patrols
        </Typography>
        <div>
          <h2>Patrol Details</h2>
        </div>
        {isLoading ? (
          <Typography>Loading...</Typography>
        ) : (
          <>
            <DataGrid
              sx={{ width: 0.9 }}
              rows={rows}
              pagination
              columns={[locationColumn, ...getPatrolsColumns(constants.resourceStatuses, constants.resourceTypes)]}
              onRowClick={handleRowClick}
              paginationModel= {paginationModel}
              onPaginationModelChange={setPaginationModel}
              pageSizeOptions={[10, 20, 50]}
              disableColumnResize
              density="compact"
              slotProps={{
                filterPanel: {
                  filterFormProps: {
                    logicOperatorInputProps: {
                      variant: "outlined",
                      size: "small",
                    },
                    columnInputProps: {
                      variant: "outlined",
                      size: "small",
                      sx: { mt: "auto" },
                    },
                    operatorInputProps: {
                      variant: "outlined",
                      size: "small",
                      sx: { mt: "auto" },
                    },
                    valueInputProps: {
                      InputComponentProps: {
                        variant: "outlined",
                        size: "small",
                      },
                    },
                  },
                },
              }}
            />
            { showModal && <Modal
              type="PATROL"
              open={showModal}
              onClose={() => {
                  setSelectedEntity(null);
                  setShowModal(false);
              }}
              entity={selectedEntity}
            /> }
          </>
        )}
      </Box>
    </>
  );
};

export default PatrolsPage;
